import { PTProps } from '@/features/editor/widgets/price-test/props';

export function hasNoSelectedProducts(
  priceTestOptions: (PTProps | undefined)[],
) {
  return (
    priceTestOptions.length > 0 &&
    priceTestOptions.every((options) => {
      if (options?.matchType === `manual`) {
        return !options.manualProducts?.length;
      }
      return !options?.rules?.rules?.length;
    })
  );
}
